import React from 'react';

const DropzoneContext = React.createContext();

export default DropzoneContext;
